import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import EntradaVereador, { FundoEntrada, EntradaCarregando } from '../components/EntradaVereador'; // PLENARIUM:ENTRADA_VEREADOR

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function LoginVereadorSlug() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { loginVereador, logout, usuario } = useAuth();
  const [camara, setCamara] = useState(null);
  const [naoAchou, setNaoAchou] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (usuario?.role === 'vereador') {
      navigate('/vereador');
      return;
    }
    if (usuario?.role === 'admin') {
      logout();
    }
  }, [usuario, navigate, logout]);

  useEffect(() => {
    axios.get(`${API}/api/publica/camara/${slug}`)
      .then(res => setCamara(res.data))
      .catch(() => setNaoAchou(true));
  }, [slug]);

  const entrar = async (cpf, senha) => {
    try {
      await loginVereador(cpf, senha);
      navigate('/vereador');
    } catch (err) {
      setErro(err.response?.data?.error || 'CPF ou senha inválidos.');
    }
  };

  if (naoAchou && !camara) {
    return (
      <FundoEntrada>
        <div className="ev-caixa" style={{ textAlign: 'center' }}>
          <h1 className="ev-titulo" style={{ fontSize: '1.6rem' }}>Câmara não encontrada</h1>
          <p className="ev-sub">Confira o endereço de acesso enviado pela Câmara.</p>
        </div>
      </FundoEntrada>
    );
  }

  if (!camara) return <EntradaCarregando />;

  return <EntradaVereador camara={camara} onEntrar={entrar} erro={erro} setErro={setErro} />;
}
